module.exports = __webpack_public_path__ + "427a3ab3ef7b5c54606182ebc28059ac.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./photo.svg
 ** module id = 478
 ** module chunks = 0
 **/